<template>
  <div class="mall-cart-item-list">
    <div class="mall-cart-item-list__select-all" @click="$emit('toggle-all')">
      <MallCheckBox :checked="allSelected" :disabled="selectableCount === 0" />
      <span class="mall-cart-item-list__select-all-text">전체 선택 ({{ selectableCount }}건)</span>
    </div>
    <div class="mall-cart-item-list__items">
      <MallCartItem
        v-for="item in items"
        :key="item.id"
        :item="item"
        :selected="selectedIds.indexOf(item.id) > -1"
        @toggle="$emit('toggle', item.id)"
        @delete="$emit('delete', item.id)"
        @quantity-change="$emit('quantity-change', item.id, $event)"
        @quantity-max="$emit('quantity-max', item.id, $event)"
      />
    </div>
  </div>
</template>

<script>
import MallCheckBox from '@/components/new/atoms/MallCheckBox.vue'
import MallCartItem from '@/components/new/molecules/MallCartItem.vue'

export default {
  name: 'MallCartItemList',
  components: {
    MallCheckBox,
    MallCartItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // 판매종료 상품은 선택 불가
    selectableCount() {
      return this.items.filter(item => !item.soldOut).length
    },
    allSelected() {
      return this.selectableCount > 0 && this.items.every(item => item.soldOut || this.selectedIds.indexOf(item.id) > -1)
    },
  },
}
</script>

<style scoped>
.mall-cart-item-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mall-cart-item-list__select-all {
  display: flex;
  padding: 0 4px;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.mall-cart-item-list__select-all-text {
  flex: 1;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}

.mall-cart-item-list__items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallCartItemList.vue